import { NotificationWidget } from "./widget/notification-widget";
import { RefreshWidget } from "./widget/refresh-widget";
import { InstallWidget } from "./widget/install-widget";

export function Dashboard() {
  return (
    <div className="w-full flex flex-col p-6 space-y-4 mx-auto">
      <div className="flex mx-auto gap-2 rounded-lg border-foreground/80 border-2 bg-secondary p-2 px-4">
        <RefreshWidget />
        <NotificationWidget />
        <InstallWidget />
      </div>
    </div>
  );
}
